import { formatDate, secondsSinceMidnightToTimeString } from '@/helpers/dateHelper';
import { getRequestStatus } from '@/helpers/requestStatusHelper';
import { strings } from '@/services/translation/strings';
import type { ScheduleChangeRequest } from '@/services/workingPatterns/useWorkingPatternRequests';
import { ReactNode } from 'react';
import { StatusChip } from './RequestStatusChip';

interface ScheduleChangeRequestDetailsCardProps {
  request: ScheduleChangeRequest;
  showUpdatedDate?: boolean;
  updatedOn?: string;
  actions?: ReactNode;
}

const formatTime = (value?: number) => (value == null ? 'Not scheduled' : secondsSinceMidnightToTimeString(value));

export const ScheduleChangeRequestDetailsCard = ({ request, actions }: ScheduleChangeRequestDetailsCardProps) => (
  <div className="space-y-8">
    <div className="space-y-1">
      <p className="font-semibold">{strings.common.requestStatus}</p>
      <StatusChip status={getRequestStatus(request.state)} />
      <p className="text-gray-400">{strings.common.requestSubmitted(formatDate(request.requestedOn))}</p>
      {request.rejectionReason && (
        <div>
          <p className="font-semibold">{strings.timeshift.teamMember.requests.scheduleUpdate.rejectionReason}</p>
          <p>{request.rejectionReason}</p>
        </div>
      )}
    </div>
    <div className="space-y-4">
      <div>
        <p className="font-semibold">{strings.timeshift.teamMember.requests.scheduleUpdate.effectiveFrom}</p>
        <p>{formatDate(request.effectiveFrom)}</p>
      </div>
      {request.dayChanges?.map(change => (
        <div key={`${change.dayNumber}-${change.slotNumber}`} className="flex flex-row space-x-32">
          <div className="w-32">
            <p className="font-semibold">
              {strings.timeshift.teamMember.requests.scheduleUpdate.hoursBefore(change.day)}
            </p>
            <p>
              {formatTime(change.before?.startTime)} - {formatTime(change.before?.endTime)}
            </p>
          </div>
          <div className="w-32">
            <p className="font-semibold">
              {strings.timeshift.teamMember.requests.scheduleUpdate.hoursAfter(change.day)}
            </p>
            <p>
              {formatTime(change.after?.startTime)} - {formatTime(change.after?.endTime)}
            </p>
          </div>
        </div>
      ))}
    </div>
    {actions}
  </div>
);
